<template>
  <div
    class="chapter-box"
    :class="`ch_${chapter.id} ${badge && 'chapter-box--badge'}`"
  >
    <svg
      class="cm_bg"
      width="15"
      height="13"
      viewBox="0 0 15 13"
      v-resize.border="handleResize"
    >
      <title>{{chapter.name}}</title>
      <text x="7.5" width="15" y="7.25">
        <tspan class="text" :style="{ fontSize: fontSize + 'px' }">{{ chapter.abbreviation }}</tspan>
      </text>
      <polygon
        class="triangle cm_fill"
        points="2,12 2,16 6,12"
      />
    </svg>

    <svg
      v-if='badge'
      class="team-badge"
      :width="badgeWidth"
      height="13"
      :viewBox="'0 0 ' + badgeWidth + ' 13'"
      >
      <text :x="badgeWidth / 2" :width="badgeWidth" y="7.25">
        <tspan class="text" :style="{ fontSize: fontSize + 'px' }">{{ badge }}</tspan>
      </text>
      <text class="badge-sizing-rect">
        <tspan class="text" :style="{ fontSize: range[0] + 'px' }" v-resize="handleBadgeResize">{{ badge }}</tspan>
      </text>
    </svg>
  </div>
</template>

<script>
/**
 * To make the badge type legible at more sizes, we dynamically scale the text size based on the width of the container;
 * starting at 6px (when the viewBox is 190w), the text scales to 9px (when the SVG viewBox is 30w) to make the text slightly larger.
 * The badge has dynamic text, so we determine the SVG's width based on the largest possible size of the text.
 */
import { linearScale } from "../lib/math"

const range = [9, 6]
const scale = linearScale({
  domain: [30, 190],
  range,
  clamp: true,
})

export default {
  data() {
    return {
      range,
      badgeWidth: 15,
      fontSize: 7,
    }
  },

  props: {
    chapter: {
      type: Object
    }, 
    badge: {
      type: String
    }
  },

  methods: {
    handleResize(entry) {
      this.fontSize = scale(entry.contentRect.width)
    },
    handleBadgeResize(entry) {
      // entry.contentRect reports 0px on tspans in firefox?
      this.badgeWidth = entry.target.getBBox().width + 4
    }
  }
};
</script>

<style lang='scss' scoped>
  .chapter-box {
    display: flex;
    justify-content: flex-end;
  }

  .team-badge {
    color: var(--white);
    background: var(--black);
  }
  .badge-sizing-rect {
    opacity: 0;
    -webkit-user-select: none; // safari
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/chapter-box.vue?b40c417c